/* Laat Hy Val Waar Hy Wil: Black Friday interactions (no dependencies) */
(() => {
  'use strict';
  const T = window.theme || { routes: {}, strings: {} };
  const root = ((T.routes && T.routes.root) || '/').replace(/\/?$/, '/');
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* Hide sale-only content once the sale has ended (guards against cached pages) */
  const now = Date.now();
  $$('[data-bf-hide-after]').forEach((el) => {
    const t = parseInt(el.getAttribute('data-bf-hide-after'), 10) * 1000;
    if (t && now > t) el.hidden = true;
  });

  /* Countdowns to the real start / end dates */
  $$('[data-bf-countdown]').forEach((el) => {
    const end = parseInt(el.getAttribute('data-end'), 10) * 1000;
    if (!end || end <= Date.now()) { el.hidden = true; return; }
    const pad = (n) => String(n).padStart(2, '0');
    const set = (sel, n) => { const node = el.querySelector(sel); if (node) node.textContent = pad(n); };
    let timer = null;
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) { el.hidden = true; if (timer) clearInterval(timer); return; }
      const s = Math.floor(left / 1000);
      set('[data-d]', Math.floor(s / 86400));
      set('[data-h]', Math.floor((s % 86400) / 3600));
      set('[data-m]', Math.floor((s % 3600) / 60));
      set('[data-s]', s % 60);
    };
    tick();
    el.hidden = false;
    timer = setInterval(tick, 1000);
  });

  /* Deal picker sets the product form quantity */
  document.addEventListener('change', (e) => {
    const r = e.target.closest('[data-bf-qty]');
    if (!r) return;
    const scope = r.closest('[data-product-section]') || document;
    const input = scope.querySelector('form.product-form input[name="quantity"]');
    if (input) input.value = r.value;
  });
  $$('[data-bf-qty]:checked').forEach((r) => r.dispatchEvent(new Event('change', { bubbles: true })));

  /* Cart nudge: add more units */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-bf-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-bf-add'), 10), quantity: parseInt(b.getAttribute('data-bf-add-qty'), 10) || 1 }], sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
      if (b.closest('[data-cart-page]') || !data.sections || !data.sections['cart-drawer']) { window.location.reload(); return; }
      const html = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      const fresh = html.querySelector('.drawer__panel');
      const current = document.querySelector('[data-cart-drawer] .drawer__panel');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      $$('[data-cart-count]').forEach((n) => { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
    } catch (ex) {
      b.disabled = false;
      alert(ex.message || T.strings.cartError || 'Something went wrong. Please try again.');
    }
  });
})();
